<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/LeaseIDTs"
        >Financial Services</b-breadcrumb-item
      >
      <b-breadcrumb-item active>Lease IDTs</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="card">
      <div class="bg-dark card-header text-white">
        <div class="row">
          <div class="col text-start">Lease IDTs</div>
          <div class="col" style="text-align:right;">Total: {{ totalAmountCharged | currency }}</div>
        </div>
      </div>
      <div class="card-body">
        <AppNotification type="info" v-if="currentLeaseIDTNumber">
          Current Lease IDT Number is {{currentLeaseIDTNumber}}
        </AppNotification>

        <!-- The collapsable filter options -->
        <AppFormCardCollapsable
          :display-footer="true"
          class="mb-3"
          @submit.prevent="onFilterSubmit()"
        >
          <template v-slot:header>Filter</template>
          <template v-slot:body>
            <div class="form-row">
              <div class="col-md-4 col-sm-6 form-group">
                <label>SL</label>
                <input
                  class="form-control"
                  placeholder="SL Number"
                  v-model="filterOptions.sl"
                />
              </div>
              <div class="col-md-4 col-sm-6 form-group">
                <label>SA</label>
                <input
                  class="form-control"
                  placeholder="SA Number"
                  v-model="filterOptions.sa"
                />
              </div>
              <div class="col-md-4 col-sm-6 form-group">
                <label>FAMIS Department Code</label>
                <input
                  class="form-control"
                  placeholder="FAMIS Department Code"
                  v-model="filterOptions.famisDepartment"
                />
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <button class="btn btn-primary" type="submit">Apply</button>
          </template>
        </AppFormCardCollapsable>

        <div class="d-print-none dropdown mb-3 text-right">
          <button
            aria-expanded="false"
            aria-haspopup="true"
            class="btn btn-secondary dropdown-toggle"
            data-toggle="dropdown"
            style="width: 100px"
            type="button"
            :disabled="isPerformingAction"
          >
            <span>Actions</span>
          </button>
          <div class="dropdown-menu">
            <RouterLink
              :to="{ name: 'AddLeaseIDT' }"
              class="btn btn-outline-light dropdown-item text-left"
              title="Add New Record"
            >
              <i class="fa fa-plus"></i>Add Record
            </RouterLink>

            <a @click.prevent="downloadLeaseIDTFrozenAndMissingAccounts()" class="btn btn-outline-light dropdown-item text-left"
              href="javascript:void(0)" title="Export missing and frozen lease IDT account list to a CSV">
                <i class="fa fa-file-excel"></i>Download Missing and Frozen Accounts .csv
            </a>
          </div>
        </div>
        
        <BTable
          :busy="isLoading"
          :fields="tableFields"
          :items="leaseIDTs"
          :responsive="true"
          show-empty
          striped
          table-class="table-align-middle"
        >
          <template v-slot:cell(null)="row">
            <div class="btn-group">
              <router-link
                :to="{
                  name: 'EditLeaseIDT',
                  params: {
                    sl: row.item.sl,
                    sa: row.item.sa,
                    famisDepartment: row.item.famisDepartment,
                    amountCharged: row.item.amountCharged
                 },
                }"
                class="btn btn-sm btn-warning d-print-none"
                data-toggle="tooltip"
                title="Edit Lease IDT Details"
              >
                <i class="fa fa-pencil-alt"></i>Edit
              </router-link>
            </div>
          </template>
          <template v-slot:cell(amountCharged)="row">
            {{ row.item.amountCharged | currency(true) }}
          </template>

          <template v-slot:cell(accountStatus)="row">
            {{ row.item.accountMissing ? 'Missing' : row.item.accountFrozen ? 'Frozen' : 'Active' }}
          </template>

           <!-- Footer Pagination -->
          <template v-slot:custom-foot>
            <b-tr>
              <b-td :colspan="tableFields.length">
                <AppTablePagination
                  :page.sync="filterOptions.page"
                  :pageSize.sync="filterOptions.pageSize"
                  :totalCount.sync="totalLeaseIDTs"
                  v-on:update:page="loadData()"
                  v-on:update:pageSize="onFilterSubmit()"
                ></AppTablePagination>
              </b-td>
            </b-tr>
          </template>
        </BTable>
        </div>
    </div>
  </div>
</template>

<script>
import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
import LeaseIDTService from "../../services/LeaseIDTsService";
import AppTablePagination from "@/components/shared/AppTablePagination";
import AppNotification from "@/components/shared/AppNotification";
import { ToastType } from "@/services/models/shared/ToastType";
import {currency} from "@/filters/Currency";



export default {
  components: {
    AppFormCardCollapsable,
    AppNotification,
    AppTablePagination,

  },
  filters: {
      currency
  },
  data() {
    return {
      leaseIDTs: [],
      totalLeaseIDTs: 0,
      filterOptions: {
        page: 1,
        pageSize: 10,
        sl: null,
        sa: null,
        famisDepartment: null
      },
      isLoading: false,
      tableFields: [
        { key: "null", label: "", thStyle: "width:175px" },
        { key: "sl", label: "SL" },
        { key: "sa", label: "SA" },
        { key: "famisDepartment", label: "FAMIS Department" },
        { key: "amountCharged", label: "Amount Charged" },
        { key: "accountStatus", label: "Account Status" }
      ],
      isPerformingAction: false,
      totalAmountCharged: 0,
      currentLeaseIDTNumber: null
    };
  },
  methods: {
    loadData() {
      const vm = this;
      this.isLoading = true;

      LeaseIDTService.getLeaseIDTs(this.filterOptions)
        .then((responseOne) => {
          vm.leaseIDTs = responseOne.data;
          vm.totalLeaseIDTs = responseOne.totalCount;

          LeaseIDTService.getTotalAmountCharged()
            .then((responseTwo) => {
              vm.totalAmountCharged = responseTwo;

              LeaseIDTService.getCurrentLeaseIDTNumber()
                .then((responseThree) => {
                  vm.currentleaseIDTNumber = responseThree;
                })
                .catch(() => {
                  vm.redirectToError();
                })
                .finally(() => {
                  vm.isLoading = false;
                });
            })
            .catch(() => {
              vm.redirectToError();
            })
        })
        .catch(() => {
          vm.redirectToError();
        });
    },
    onFilterSubmit() {
      this.filterOptions.page = 1;
      this.loadData();
    },
  },
    /**
     * @description Downloads the frozen and missing accounts list for lease idts CSV export to the user's browser
     */
    downloadLeaseIDTFrozenAndMissingAccounts() {
        this.isPerformingAction = true;
        const vm = this;

        LeaseIDTService.downloadLeaseIDTFrozenAndMissingAccounts()
            .catch(() => {
                vm.alert(ToastType.Danger, "Unable to generate report. Please contact NIS if the issue persists.")
            })
            .finally(() => {
                this.isPerformingAction = false
            });
    },

  created() {
    this.loadData();
  }
};
</script>
